import React from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  FaHome,
  FaFileAlt,
  FaTruck,
  FaUsers,
  FaClipboardList,
  FaFileInvoice,
  FaBoxes
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const menuItems = [
  { name: "Dashboard", icon: <FaHome /> },
  { name: "Orders", icon: <FaFileAlt />, subItems: ["Estimate", "Sales Order", "Delivery Schedule"] },
  { name: "Vendors", icon: <FaTruck />, subItems: ["Vendor PO", "Vendor Inquiry", "Vendor Quotation"] },
  { name: "Customers", icon: <FaUsers />, subItems: ["Customer Inquiry", "EstimateCustomer"] },
  { name: "Dispatch Notification", icon: <FaClipboardList /> },
  { name: "Delivery Challan", icon: <FaFileInvoice /> },
  { name: "GRN", icon: <FaBoxes /> }
];

const permissions = [
  { "MainMenu": "Estimate", "action": "Approval,Approve,Cancellation,Save,View", "roles": "SS,MIS" },
  { "MainMenu": "Sales Order", "action": "Approve,Save,View", "roles": "MIS,MGT" },
  { "MainMenu": "Delivery Schedule", "action": "Approve,Cancel,Modify,Save,Split,View", "roles": "MIS,ZH" },
  { "MainMenu": "Vendor PO", "action": "Approve,Close,Save,View", "roles": "MIS,AC" },
  { "MainMenu": "Dispatch Notification", "action": "Approve,Save,View", "roles": "MIS,RM" },
  { "MainMenu": "Delivery Challan", "action": "Accept,Dispatch,Rejected,Save,View", "roles": "MIS,CLT" },
  { "MainMenu": "GRN", "action": "Accept,Deliver,Reject,Save,View", "roles": "MIS,AGG" },
  { "MainMenu": "Vendor Inquiry", "action": "Approve,Save,View", "roles": "MIS,VDR" },
  { "MainMenu": "Customer Inquiry", "action": "SAVE,SUBMIT,VIEW", "roles": "MIS,SS" },
  { "MainMenu": "EstimateCustomer", "action": "Accept,Reject,View", "roles": "MIS,SH" },
  { "MainMenu": "Vendor Quotation", "action": "Approve,Save,View", "roles": "MIS,SS" }
];

const userRole = "MIS";

const hasViewPermission = (menuName) => {
    const menu = permissions.find((item) => item.MainMenu === menuName);
    
    if (!menu) return false; // If menu item is not found, deny access.

    const allowedRoles = menu.roles.split(","); // Convert "MIS,SH" -> ["MIS", "SH"]
    const allowedActions = menu.action.split(","); // Convert "Accept,Reject,View" -> ["Accept", "Reject", "View"]

    return allowedActions.includes("View") && allowedRoles.includes(userRole);
};

  



const Sidebar = () => {
     const navigate = useNavigate();
     const handleMenuClick = (menuName) => {
        if (hasViewPermission(menuName)) {
          toast.success(`✅ Access Granted to ${menuName}`);
          if (menuName === "EstimateCustomer") {
              navigate("/estimateManagement");
            }
        } else {
          toast.error(`⛔ Access Denied for ${menuName}`);
        }
      };
  return (
    <div className="text-black p-4">
      <ToastContainer />
      <h2 className="text-xl font-bold mb-4">Menu</h2>
      <ul>
        {menuItems.map((menu, index) => (
          <li key={index} className="mb-2">
            <div
              className={`flex items-center gap-2 font-semibold cursor-pointer ${
                hasViewPermission(menu.name) ? "hover:text-black" : "text-gray-500"
              }`}
              onClick={() => handleMenuClick(menu.name)}
            >
              {menu.icon} {menu.name}
            </div>
            {menu.subItems && (
              <ul className="ml-4 mt-1">
                {menu.subItems.map((sub, idx) => (
                  <li
                    key={idx}
                    className={`pl-4 text-sm cursor-pointer ${
                      hasViewPermission(sub) ? "text-gray-300 hover:text-black" : "text-gray-500"
                    }`}
                    onClick={() => handleMenuClick(sub)}
                  >
                    {sub}
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;
